import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Log } from 'app/core/logging/log';
import { AppService } from 'app/services/app/app.service';
import { EventsService } from 'app/services/events/events.service';

@Component({
    selector: 'app-signup-page',
    templateUrl: './signup-page.component.html',
    styleUrls: ['./signup-page.component.scss']
})
export class SignupPageComponent implements OnInit, OnDestroy {

    mode: string = 'signin';
    
    
    constructor(
        private appService: AppService,
        private eventsService: EventsService,
        private router: Router,
        private route: ActivatedRoute) { }

    ngOnInit() {
        let pathname:string = window.location.pathname;
        if(pathname.indexOf('signin') != -1){
            this.mode = 'signin';
        }else if(pathname.indexOf('signup') != -1){
            this.mode = 'signup';
        }else if(pathname.indexOf('reset') != -1){
            this.mode = 'reset';
        }

        this.eventsService.subscribe('getProfile', result => {
            this.redirectLanging();
        });
        this.redirectLanging();
        
    }

    ngOnDestroy() {
        this.eventsService.destroy('getProfile');
    }

    redirectLanging(){
        if(this.appService.autenticado()){
            this.router.navigate(["/"]);
        }
    }

    goTo(value: string){
        Log.debug('goTo');
        this.router.navigate([value]);
    }

    callbackSignin(){
        this.redirectAfterAuth();
    }

    callbackSignup(){
        Log.debug('callbackSignup');
        this.redirectAfterAuth();
    }

    private redirectAfterAuth(){
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        if(returnUrl != null){
            Log.debug('callbackSignin', {returnUrl: returnUrl});
            setTimeout(()=> this.router.navigateByUrl(returnUrl), 500);
            return;
        }

        if(this.appService.kiosk){
            this.router.navigate(['/reserve', this.appService.kiosk, 'locker-location']);
            return;
        }

        this.router.navigate(['/locker-location']);
    }

    callbackReset(){
        Log.debug('callbackReset');   
    }
    
}
